import request from "./request";
import URLS from "../configurations/urls";
import Api from "./Api";

class DiscoverApi {
  static findDiscoverTransactions(data = {}) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_DISCOVER_TRANSACTIONS}`;
    options.params = data;
    return request.get(options);
  }

  static findDiscoverTransaction(reference) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_DISCOVER_TRANSACTIONS}/${reference}`;
    return request.get(options);
  }

  static getDuplicateTransactions(data = {}) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_DISCOVER_TRANSACTIONS}/duplicates`;
    options.params = data;
    return request.get(options);
  }

  static getDiscoverReasonCodes(data = {}) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_DISCOVER_REASONCODES}`;
    options.params = data;
    return request.get(options);
  }

  static getDiscovercases(data = {}) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_DISCOVER_CASES}`;
    options.params = data;
    return request.get(options);
  }

  static getCasesRequest(data = {}) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_DISCOVER_CASES}/requests`;
    options.params = data;
    return request.get(options);
  }

  static getDiscoverCase(caseNumber) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_DISCOVER_CASES}/${caseNumber}`;
    return request.get(options);
  }

  static getCaseDocuments(caseNumber) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_DISCOVER_CASES}/${caseNumber}/documents`;
    return request.get(options);
  }

  static downloadCaseDocuments(documentId, caseNumber) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_DISCOVER_CASES}/${caseNumber}/documents/${documentId}`;
    return request.get(options);
  }

  static createCase(data, requestType, requestId) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    if (requestType) {
      options.url += `${URLS.ARBITER_API_DISCOVER_CASES}/requests/${requestId}/${requestType}`;
    } else {
      options.url += `${URLS.ARBITER_API_DISCOVER_CASES}`;
    }

    options.data = data;
    return request.post(options);
  }

  static updateCase(data, caseNumber, requestType, requestId) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    if (requestType) {
      options.url += `${URLS.ARBITER_API_DISCOVER_CASES}/requests/${requestId}/${requestType}`;
    } else {
      options.url += `${URLS.ARBITER_API_DISCOVER_CASES}/${caseNumber}`;
    }
    options.data = data;
    return request.post(options);
  }

  static createCaseNote(data, caseNumber) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_DISCOVER_CASES}/${caseNumber}/notes`;
    options.data = data;
    return request.post(options);
  }

  static addCaseDocuments(data, caseNumber) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_DISCOVER_CASES}/${caseNumber}/documents`;
    options.data = data;
    return request.post(options);
  }

  static cancelCaseRequest(requestId, data = {}) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_DISCOVER_CASES}/requests/${requestId}`;
    options.data = data;
    return request.post(options);
  }
}

export default DiscoverApi;



// WEBPACK FOOTER //
// ./src/api/DiscoverApi.js